'use client';
import React, { useEffect, useState } from 'react';
import { Home, Coin1, Ticket, ShoppingCart } from 'iconsax-react';
import { useRouter } from 'next/navigation';
import { feathersClient } from '@/components/connection/page';
import { useAppSelector } from '@/redux/store';
import Link from 'next/link';

interface User {
    firstname: string;
    lastname: string;
    email: string;
}

const BottomAppNavbar = () => {
    const [user, setUser] = useState<User | null>(null);
    const [currentPath, setCurrentPath] = useState('');
    const router = useRouter();
    const [isPWA, setIsPWA] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [cartItems, setCartItems] = useState(0);
    const [storedUser, setStoredUser] = useState<string | null>(null);
    const [loading, setLoading] = useState(true); // New loading state

    const cartArray = useAppSelector((state) => state.cartReducer);

    useEffect(() => {
        const checkPWAStatus = () => {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            setIsPWA(isStandalone);
            setLoading(false); // Stop loading once check is done
        };

        setLoading(true);
        setTimeout(checkPWAStatus, 1000); // Simulate a delay before checking
    }, []);

    const handleClick = (event: any) => {
        event.preventDefault();
        setIsClicked(true);
        if (isPWA) {
            window.location.href = 'https://razilia.com';
        } else {
            window.open('https://razilia.com', '_blank', 'noopener noreferrer');
        }
    };

    useEffect(() => {
        setStoredUser(localStorage.getItem('users'));
    }, []);

    useEffect(() => {
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
            feathersClient.service('api/v1/cart').find({ query: { userId: parsedUser._id } })
                .then((existingCart: any) => {
                    if (existingCart.data?.length > 0 && Array.isArray(existingCart.data[0].cartItems[0].ticketGroup)) {
                        setCartItems(existingCart.data[0].cartItems[0].ticketGroup.length);
                    }
                })
                .catch((error: any) => console.error('Error fetching cart:', error));
        } else {
            const storedCart = localStorage.getItem('cart');
            if (storedCart) {
                const parsedCart = JSON.parse(storedCart);
                setCartItems(parsedCart?.ticketGroup?.length);
            }
        }
    }, [cartArray, storedUser]);

    useEffect(() => {
        const storedUser = localStorage.getItem('users');
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser({
                    firstname: parsedUser.firstname,
                    lastname: parsedUser.lastname,
                    email: parsedUser.email,
                });
            } catch (error) {
                console.error('Failed to parse stored user:', error);
            }
        }
        setCurrentPath(window.location.pathname);
    }, []);

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
                <div className="text-center">
                    <div className="w-10 h-10 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
                    <p className="mt-3 text-blue-500">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {currentPath == '/' && <><br /><br /><br /><br /><br /></>}

            <div className='bg-[#397BEA] flex justify-between items-center px-4 h-20 fixed bottom-0 w-full'>
                <div className="flex flex-col items-center">
                    <Home size="32" color={currentPath === '/' ? '#FF994C' : '#FFFFFF'} variant="Bold" onClick={() => router.push('/')} />
                    <span className={`text-sm ${currentPath === '/' ? 'text-orange-500' : 'text-white'}`} >Home</span>
                </div>

                <div className="flex flex-col items-center">
                    <a href="#" onClick={handleClick}>
                        <Coin1 size="32" color="#FFFFFF" variant="Bulk" />
                        <span className={`text-sm ${isClicked ? 'text-orange-500' : 'text-white'}`}>Razz</span>
                    </a>
                </div>

                <div className="flex flex-col items-center">
                    <Ticket size="32" color={currentPath === '/my-tickets' ? '#FF994C' : '#FFFFFF'} variant="Bold" onClick={() => router.push('/my-tickets')} />
                    <span className={`text-sm ${currentPath === '/my-tickets' ? 'text-orange-500' : 'text-white'}`}>My Tickets</span>
                </div>

                <Link href="/cart">
                    <div className="flex flex-col items-center">
                        <ShoppingCart size="32" color={currentPath === '/cart' ? '#FF994C' : '#FFFFFF'} variant="Bold" />
                        <span className={`text-sm ${currentPath === '/cart' ? 'text-orange-500' : 'text-white'}`}>Cart</span>
                        {cartItems > 0 && (
                            <h2 className='text-white text-[11px] bg-red-600 rounded-lg px-1 absolute mb-5 ml-3 '>
                                {cartItems < 10 ? `0${cartItems}` : cartItems}
                            </h2>
                        )}
                    </div>
                </Link>

                <div className="flex flex-col items-center" onClick={() => router.push('/homeprofile')}>
                    <div className="flex items-center justify-center bg-white text-black rounded-full w-8 h-8">
                        {user && user.firstname ? (
                            user.firstname.charAt(0).toUpperCase()
                        ) : (
                            <svg className="w-8 h-8" viewBox="0 0 24 24" fill={currentPath === '/homeprofile' ? '#FF994C' : '#397bea'} xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
                            </svg>
                        )}
                    </div>
                    <span className={`text-sm ${currentPath === '/homeprofile' ? 'text-orange-500' : 'text-white'}`}>Profile</span>
                </div>
            </div>
        </>
    );
};

export default BottomAppNavbar;
